<template>
  <aside class="rec-sidebar">
    <nav class="rec-nav">

      <router-link to="/recognition" class="rec-nav-item" active-class="rec-nav-item--active" exact>
        <span class="rec-nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
        </span>
        <span class="rec-nav-label">Recognition Feed</span>
      </router-link>

      <!--<router-link to="/recognition/my-activity" class="rec-nav-item" active-class="rec-nav-item--active">
        <span class="rec-nav-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
        </span>
        <span class="rec-nav-label">My Activity</span>
        <span class="rec-nav-badge">Private</span>
      </router-link>-->

      <router-link to="/recognition/give" class="rec-nav-item" active-class="rec-nav-item--active">
        <span class="rec-nav-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
            <circle cx="12" cy="8" r="6"/>
            <path d="M8.21 13.89L7 22l5-3 5 3-1.21-8.11"/>
          </svg>
        </span>
        <span class="rec-nav-label">Give Recognition</span>
      </router-link>

      <router-link to="/recognition/history" class="rec-nav-item" active-class="rec-nav-item--active">
        <span class="rec-nav-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
            <path d="M3 12a9 9 0 1 0 3-6.7"/>
            <path d="M3 3v6h6"/>
            <path d="M12 7v5l3 3"/>
          </svg>
        </span>
        <span class="rec-nav-label">My History</span>
      </router-link>

    </nav>
  </aside>
</template>

<script>
export default {
  name: "RecognitionSidebar",
};
</script>

<style lang="scss" scoped>

// ─────────────────────────────────────────────────────────
// Desktop sidebar — right border = separator line,
// align-self: stretch makes it run full column height
// ─────────────────────────────────────────────────────────
.rec-sidebar {
  border-right: 1px solid #e5e7eb;
  background: #fff;
  align-self: stretch;
}

.rec-nav {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px 16px 4px 0;
  position: sticky;
  top: 1.5rem;
}

.rec-nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 14px;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #4b5563;
  text-decoration: none;
  transition: background 0.12s ease, color 0.12s ease;

  &:hover {
    background: #f9fafb;
    color: #111827;
    text-decoration: none;
    .rec-nav-icon svg { stroke: #374151; }
  }

  // Active: light blue bg + blue text
  &--active,
  &.router-link-active {
    background: #eff6ff;
    color: #2563eb;
    .rec-nav-icon svg { stroke: #2563eb; }
  }
}

.rec-nav-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  height: 18px;

  svg {
    width: 16px;
    height: 16px;
    stroke: #9ca3af;
    transition: stroke 0.12s ease;
  }
}

.rec-nav-label {
  flex: 1;
  white-space: nowrap;
}

.rec-nav-badge {
  font-size: 0.65rem;
  font-weight: 500;
  color: #6b7280;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  padding: 1px 7px;
  border-radius: 20px;
  white-space: nowrap;
}

// ─────────────────────────────────────────────────────────
// Mobile — full-width horizontal scroll strip
// Sits above the feed, separated by a bottom border line
// ─────────────────────────────────────────────────────────
@media (max-width: 768px) {
  .rec-sidebar {
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
    align-self: auto;
    width: 100%;
    background: #fff;
    // Flush with container edges — no side padding on the aside itself
    padding: 0;
  }

  .rec-nav {
    flex-direction: row;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    padding: 0 1rem;            // side breathing room when scrolling
    gap: 0;
    position: static;
    border-bottom: none;        // border is on .rec-sidebar already

    &::-webkit-scrollbar { display: none; }
    scrollbar-width: none;
  }

  .rec-nav-item {
    flex-shrink: 0;
    padding: 10px 14px;
    border-radius: 0;
    font-size: 0.82rem;
    gap: 7px;
    // Bottom border as the active indicator
    border-bottom: 2px solid transparent;

    &--active,
    &.router-link-active {
      background: transparent;
      color: #2563eb;
      border-bottom-color: #2563eb;
      .rec-nav-icon svg { stroke: #2563eb; }
    }

    &:hover {
      background: #f9fafb;
    }
  }

  // Hide "Private" badge on narrow screens to save space
  .rec-nav-badge { display: none; }

  // Hide icon on mobile to keep tabs tight — label only
  .rec-nav-icon { display: none; }
}
</style>